import React, { useEffect, useState } from 'react';

const formatTimeForInput = (value) => {
    if (!value) return '';

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';

    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${hours}:${minutes}`;
};

const resolveBaseDate = (value) => {
    if (!value) return new Date();

    const parsed = new Date(value);

    if (Number.isNaN(parsed.getTime())) return new Date();

    return parsed;
};

const buildDateWithTime = (timeInput, fallbackDate) => {
    if (!timeInput) return null;

    const [hoursStr, minutesStr] = timeInput.split(':');
    const hours = Number(hoursStr);
    const minutes = Number(minutesStr);

    if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;

    const baseDate = resolveBaseDate(fallbackDate);
    const result = new Date(baseDate);

    result.setHours(hours, minutes, 0, 0);

    return result;
};

const formatBreakForInput = (value) => {
    const numeric = Number(value);

    if (Number.isNaN(numeric) || numeric <= 0) return '';

    return Math.round(numeric / 60000);
};

const WorkTimeModal = ({
    operationLabel,
    startTime,
    endTime,
    breakDuration,
    onClose,
    onSave,
}) => {
    const [startInput, setStartInput] = useState(formatTimeForInput(startTime));
    const [endInput, setEndInput] = useState(formatTimeForInput(endTime));
    const [breakInput, setBreakInput] = useState(formatBreakForInput(breakDuration));
    const [error, setError] = useState('');

    useEffect(() => {
        setStartInput(formatTimeForInput(startTime));
    }, [startTime]);

    useEffect(() => {
        setEndInput(formatTimeForInput(endTime));
    }, [endTime]);

    useEffect(() => {
        setBreakInput(formatBreakForInput(breakDuration));
    }, [breakDuration]);

    // Validoi ajat aina kun inputit muuttuvat
    useEffect(() => {
        const parsedStart = buildDateWithTime(startInput, startTime);
        const parsedEnd = buildDateWithTime(endInput, endTime || startTime);

        if (parsedStart && parsedEnd && parsedEnd < parsedStart) {
            setError('Lopetusaika ei voi olla ennen aloitusaikaa.');
        } else {
            setError('');
        }
    }, [startInput, endInput, startTime, endTime]);

    const handleSave = () => {
        // Älä tallenna jos validointivirhe
        if (error) return;

        const parsedStart = buildDateWithTime(startInput, startTime);
        const parsedEnd = buildDateWithTime(endInput, endTime || startTime);

        const parsedBreakMinutes = Number(breakInput);
        const normalizedBreak = Number.isNaN(parsedBreakMinutes) || parsedBreakMinutes < 0
            ? 0
            : parsedBreakMinutes * 60000;

        onSave({ startTime: parsedStart, endTime: parsedEnd, breakDuration: normalizedBreak });
    };

    const handleDelete = () => {
        onSave({ startTime: null, endTime: null, isDelete: true });
    };

    return (
        <div className="add-item-modal" onClick={onClose}>
            <div className="add-item-window" onClick={(e) => e.stopPropagation()}>
                <h3>Muokkaa työaikaa ({operationLabel})</h3>
                <div className="work-time-field">
                    <label htmlFor="workStartTime">Aloitusaika</label>
                    <input
                        id="workStartTime"
                        type="time"
                        value={startInput}
                        onChange={(e) => setStartInput(e.target.value)}
                    />
                </div>
                <div className="work-time-field">
                    <label htmlFor="workEndTime">Lopetusaika</label>
                    <input
                        id="workEndTime"
                        type="time"
                        value={endInput}
                        onChange={(e) => setEndInput(e.target.value)}
                    />
                </div>

                <div className="work-time-field">
                    <label htmlFor="workBreakDuration">Tauon pituus (minuutteina)</label>
                    <input
                        id="workBreakDuration"
                        type="number"
                        min="0"
                        step="1"
                        value={breakInput}
                        onChange={(e) => setBreakInput(e.target.value)}
                    />
                </div>

                {error && (
                    <p
                        className="work-time-error"
                        style={{ color: 'red', marginTop: '8px', marginBottom: '0' }}
                    >
                        {error}
                    </p>
                )}

                <div className="work-time-actions">
                    <button
                        type="button"
                        className="form-button-order form-button-delete"
                        onClick={handleDelete}
                    >
                        Poista työaika
                    </button>
                    <button
                        type="button"
                        className="form-button-order form-button-cancel"
                        onClick={onClose}
                    >
                        Peruuta
                    </button>
                    <button
                        type="button"
                        className="form-button-order form-button-submit"
                        onClick={handleSave}
                        disabled={!!error}
                    >
                        Tallenna
                    </button>
                </div>
            </div>
        </div>
    );
};

export default WorkTimeModal;
